import { useState } from "react";
import { FileText, ChevronUp, Loader2 } from "lucide-react";
import { http } from "@/lib/api";

// Lote 133 — o andamento vindo do DJEN mostra só um resumo automático (sem custo de IA). Este botão busca,
// sob demanda (1 toque), o texto integral da publicação guardado no histórico.
export default function PublicacaoCompleta({ processoId, andamentoId, testid }) {
  const [aberto, setAberto] = useState(false);
  const [texto, setTexto] = useState(null);
  const [carregando, setCarregando] = useState(false);
  const [erro, setErro] = useState(false);

  const alternar = async () => {
    if (aberto) { setAberto(false); return; }
    setAberto(true);
    if (texto !== null) return;
    setCarregando(true); setErro(false);
    try {
      const r = await http.get(`/processos/${processoId}/historico/${andamentoId}/texto`);
      setTexto(r.data?.texto || "");
    } catch { setErro(true); }
    finally { setCarregando(false); }
  };

  return (
    <div data-testid={testid}>
      <button
        type="button"
        aria-expanded={aberto}
        data-testid={testid ? `${testid}-toggle` : undefined}
        onClick={alternar}
        className="mt-0.5 inline-flex items-center gap-1 min-h-[32px] text-xs font-semibold text-stone-600 hover:text-stone-900"
      >
        {aberto ? <><ChevronUp className="w-3.5 h-3.5" strokeWidth={2} /> Esconder publicação</> : <><FileText className="w-3.5 h-3.5" strokeWidth={2} /> Ver publicação completa</>}
      </button>
      {aberto && (
        <div className="mt-1 rounded-md border border-stone-200 bg-stone-50 p-2.5">
          {carregando ? <Loader2 className="w-4 h-4 animate-spin text-stone-400" />
            : erro ? <p className="text-xs text-rose-brand">Não consegui abrir o texto. Tente de novo.</p>
            : <p data-testid={testid ? `${testid}-texto` : undefined} className="text-xs leading-relaxed text-stone-700 whitespace-pre-line break-words max-h-80 overflow-auto">{texto}</p>}
        </div>
      )}
    </div>
  );
}
